export const servicesData = [
    {
        id: 1,
        title:"Website design and development",
        description:"Website design and development - designing and building a website to meet specific requirements, such as the look and feel, functionality, and content.",
        icon:"feather-archive"
    },
    {
        id: 2,
        title:"User experience (UX) and user interface (UI) design",
        description:"User experience (UX) and user interface (UI) design - designing the look and feel of a website, including the placement of elements, the color scheme, and how users interact with the website.",
        icon:"feather-airplay"
    },
    {
        id: 3,
        title:"Responsive and mobile design",
        description:"Responsive and mobile design - ensuring that a website looks and functions well on all devices, including desktops, tablets, and mobile phones.",
        icon:"feather-settings"
    },
    {
        id: 4,
        title:"Search engine optimization (SEO) optimization",
        description:"Search engine optimization (SEO) optimization - improving a website's visibility on search engines like Google by optimizing its content, keywords, and structure.",
        icon:"feather-send"
    },
    {
        id: 5,
        title:"Website security and SSL certificate installation",
        description:"Website security and SSL certificate installation - securing a website with SSL certificates and other security measures to protect against hacking and cyber attacks.",
        icon:"feather-anchor"
    },
    {
        id: 6,
        title:"Website maintenance and updates",
        description:"Website maintenance and updates - keeping a website up-to-date with the latest security patches, content updates, and bug fixes.",
        icon:"feather-book"
    },

]